import React from 'react';
import { Section, WayPointHandler } from 'components';
import MainSlider from './MainSlider';
import HomeIntro from './HomeIntro';
import './MainBanner.scss';

const MainBanner = () => (
  <WayPointHandler path={'home'}>
    <div className={'main-banner'}>
      <HomeIntro />

      <Section stick spaceless>
        <MainSlider />
      </Section>
    </div>
  </WayPointHandler>
);

export default MainBanner;
